import React from 'react';

const SkeletonCtaBlue = () => {
    return (
        <div className="skeleton-cta-blue-wrapper xmt-20">
            <div className="container">
                <div className="cta-box br-2 xpx-10 d-flex align-items-center justify-content-between skeleton-loading">
                    <div className="text br-4 skeleton-loading"></div>
                    <div className="button br-5 skeleton-loading"></div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonCtaBlue;
